import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
    name: 'filterPipeIncomes'
})
export class FilterPipeIncomes implements PipeTransform {
    transform(incomes: any, term?: any): any {
        if (term === undefined) return incomes;
        if (term === null) return incomes;

        if (incomes != null) {
            return incomes.filter(function (income) {
                if (income.concept != undefined)
                    if (income.concept.toLowerCase().includes(term.toLowerCase()))
                        return income;
                if (income.number.toString() != undefined)
                    if (income.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return income;
                if (income.date != undefined)
                    if (moment(new Date(income.date)).format("DD/MM/YYYY").toString().toLowerCase().includes(term.toLowerCase()))
                        return income.date;
                if (income.total.toString() != undefined)
                    if (income.total.toString().toLowerCase().includes(term.toLowerCase()))
                        return income;
                if (income.payment_method.toString() != undefined)
                    if (income.payment_method.toString().toLowerCase().includes(term.toLowerCase()))
                        return income;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/income-create/filter.pipe.ts